import React from "react";

// Slow editorial marquee. Content is duplicated for a seamless loop.
// Animation pauses automatically under prefers-reduced-motion (see index.css).
export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`marquee-mask overflow-hidden ${className}`} aria-hidden="true">
      <div className="marquee-track gap-10 py-1">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-3 whitespace-nowrap font-display text-lg font-semibold text-etap-deep-300"
          >
            {item}
            <span className="text-etap-mint-500">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
